import { AxiosError, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'

import * as requests from './requests'
import { TYourWayIframeUrl } from './types'
import { ResponseError, ResponseSuccess } from '../../types'

export const KEY_YOUR_WAY_IFRAME_URL_QUERY = 'getYourWayIframeUrl'

export const useGetYourWayIframeUrlQuery = () =>
  useQuery<AxiosResponse<ResponseSuccess<TYourWayIframeUrl>>, AxiosError<ResponseError>>(
    [KEY_YOUR_WAY_IFRAME_URL_QUERY],
    () => requests.getYourWayIframeUrl()
  )
